import { useRef} from "react";
import { useNavigate } from "react-router-dom";
import Card from "./Card";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import AntiqueCategoryBadge from "./AntiqueCategoryBadge";
import styles from './Card.module.css';

// CardContainer Component
const CardContainer = ({ posts, loading, title = "Products", isWishlistPage = false, onProductClick }) => {
  // Refs and State
  const containerRef = useRef(null);
  const navigate = useNavigate();
  // Product count and display logic
  const productCount = posts?.length || 0;
  const MAX_DISPLAY = 8;
  // products per category limit
  const hasMoreProducts = productCount > MAX_DISPLAY;
  const displayPosts = posts;

  // Scroll handler
  const scroll = (direction) => {
    if (containerRef.current) {
      const scrollAmount = direction === "left" ? -300 : 300;
      containerRef.current.scrollBy({ left: scrollAmount, behavior: "smooth" });
    }
  };

  // See All handler
  const handleSeeAll = () => {
    const categoryName = typeof title === 'string' ? title : (title.name || 'Products');
    // Navigate to category products page with selected category
    navigate(`/category-products?category=${encodeURIComponent(categoryName)}`);
  };

  // Badge click handler
  const handleBadgeClick = () => {
    const categoryName = typeof title === 'string' ? title : (title.name || 'Products');
    navigate(`/category-products?category=${encodeURIComponent(categoryName)}`);
  };

  // Dynamic class based on product count
  const getContainerClass = () => {
    const isMobile = window.innerWidth <= 768;
    
    // logic for product center alignment
    if (isMobile) {
      if (productCount === 1) return `${styles.cardContainer} ${styles.centerLayout}`;
      return styles.cardContainer;
    } else {
      if (productCount <= 3) return `${styles.cardContainer} ${styles.centerLayout}`;
      return styles.cardContainer;
    }
  };

  return (
    <div className="section-container mt-5" style={{ marginBottom: '40px' }}>
      {!isWishlistPage && (
        <div onClick={handleBadgeClick} style={{ cursor: 'pointer' }}>
          <AntiqueCategoryBadge title={typeof title === 'string' ? title : (title.name || 'Category')} />
        </div>
      )}
      
      <div className={styles.cardContainerWrapper}>
        {/* Navigation Arrows - Only visible on Hover in Desktop */}
        <button className={`${styles.scrollBtn} ${styles.leftBtn}`} onClick={() => scroll("left")}>
          <FaChevronLeft />
        </button>

        <div 
          ref={containerRef} 
          className={getContainerClass()}
        >
          {loading ? (
            <div className="text-center w-100">Loading...</div>
          ) : displayPosts && displayPosts.length > 0 ? (
            displayPosts.map((post, index) => (
              <Card
                key={`${post._id}-${index}`}
                post={post}
                isWishlistPage={isWishlistPage}
                onClick={() => onProductClick ? onProductClick(post) : null}
              />
            ))
          ) : (
            <div className="w-100 text-center py-5">
              <h3 style={{ color: 'red' }}>No items found</h3>
            </div>
          )}
        </div>

        <button className={`${styles.scrollBtn} ${styles.rightBtn}`} onClick={() => scroll("right")}>
          <FaChevronRight />
        </button>
      </div>
      
      {hasMoreProducts && !isWishlistPage && (
        <div style={{ textAlign: 'center', marginTop: '20px' }}>
          <button 
            className={styles.showMoreButton}
            onClick={handleSeeAll}
          >
            See All Products
          </button>
        </div>
      )}
    </div>
  );
};

export default CardContainer;